import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';
import { VACANCY_PATH } from 'domain/recruiting/vacancy/shared/vacancyService';

export const useVacancyUrl = () => {
  const { getSingleEntityUrl, ...restUrls } = useEntityUrl({ baseLink: VACANCY_PATH });

  const getCopyEntityUrl = (id: StringOrNumber): string => `${getSingleEntityUrl(id)}/copy`;
  const getHiringRequestsUrl = (id: StringOrNumber): string => `${getSingleEntityUrl(id)}/requests`;

  return { ...restUrls, getSingleEntityUrl, getCopyEntityUrl, getHiringRequestsUrl };
};

export const useVacancyId = () => {
  const { id } = useParams<Dictionary<string>>();
  return id!;
};
